import { matchPath } from 'react-router';
import { useLocation } from 'react-router-dom';

function useTheme() {
  
  const state = useLocation();

  if (!state.pathname) {
    return 'dark';
  }

  const match = matchPath(state.pathname, {
    path: "/v4/workspace",
    exact: true,
    strict: false
  });

  return match ? 'dark' : 'light';
}

export default useTheme;